const HANDLE_BODY_REGEX = /^@?[a-z0-9][a-z0-9._-]*$/i;

export function parseProfileHandleQuery(raw) {
  const q = String(raw || '').trim();
  if (!q) return null;
  if (q.startsWith('@')) {
    const body = q.slice(1).trim().toLowerCase();
    return body.length >= 2 && HANDLE_BODY_REGEX.test(`@${body}`) ? body : null;
  }
  if (HANDLE_BODY_REGEX.test(q)) return q.toLowerCase();
  return null;
}

export function profileViewParamsFromSearch(raw) {
  const handle = parseProfileHandleQuery(raw);
  if (!handle) return null;
  return { handle };
}
